module.exports = __webpack_public_path__ + "img/wx.0c09ecec.png";